import $ from 'jquery';
import 'particles.js';

$('.js-theme-particles').each(function() {
    const $particles = $(this);
    const particlesID = $particles.attr('id');
    const particlesJSON = $particles.data('particles-json');
    window.particlesJS(particlesID, particlesJSON);
});